<template>
  <!-- 筛选标签 -->
  <div class="app-search-tag-body">
    <SearchTag ref="Type" tags="分类" :tag-data="searchCurriculumInfo.classificationList"></SearchTag>
    <SearchTag ref="Lvl" tags="难度" :tag-data="searchCurriculumInfo.lvlList"></SearchTag>
    <SearchTag ref="ContentType" tags="类型" :tag-data="contentTypeData"></SearchTag>
    <SearchTag ref="OpenType" tags="开源" :tag-data="openTypeData"></SearchTag>
  </div>
</template>

<script>

import SearchTag from "@/views/share/search/SearchTag";
import AxiosBase from "@/components/axiosBase";

export default {
  name: "SearchOpenCurriculum",
  components: {
    SearchTag
  },
  data() {
    return {
      searchCurriculumInfo: {
        classificationList: [],
        lvlList: [],
      },
      contentTypeData: [
        {
          name: '视频',
          id: 1
        },
        {
          name: '文本',
          id: 0
        }
      ],
      openTypeData: [
        {
          name: '是',
          id: 1
        },
        {
          name: '否',
          id: 0
        }
      ],
      searchRs: [],
      searchFlag: false
    }
  },
  beforeMount() {
    AxiosBase.axiosGet("/curriculum/search-in", {}).then(response => {
      if (response !== 0) {
        this.searchCurriculumInfo = response.data;
      }
    });
  },
  methods: {
    doCurriculumSearch(searchKey) {
      this.searchFlag = false;
      AxiosBase.axiosGet("/curriculum/search", {
        params: {
          key: searchKey,
          classificationId: this.$refs.Type.selectId,
          lvlId: this.$refs.Lvl.selectId,
          videoType: this.$refs.ContentType.selectId,
          openSource: this.$refs.OpenType.selectId
        }
      }).then(response => {
        if (response !== 0) {
          this.searchRs = response.data
          this.searchFlag = true;
        }
      });
    }
  }
}
</script>